import { Component } from '@angular/core';

@Component({
  selector: 'app-ipelanding',
  templateUrl: './ipelanding.component.html',
  styleUrls: ['./ipelanding.component.scss']
})
export class IpelandingComponent {

}
